import FilterParamsUtil from "../../sections/collection-grid/filter-params-util";

const CollectionFilterSpBrands = (el, onClose) => {
  let filterParams = [];

  const initialize = () => {
    el.querySelector(".fs-back-button").addEventListener("click", () => {
      el.classList.remove("show");
      onClose(false, null);
    });
    el.querySelector(".fs-close-button").addEventListener("click", () => {
      el.classList.remove("show");
      onClose(true, null);
    });
    el.querySelector(".fs-clear-button").addEventListener("click", () => {
      const newFilterParams = filterParams.filter((kv) => kv.key != "vendor");
      handleChangeFilterParams(newFilterParams);
    });
    el.querySelector(".fs-select-button").addEventListener("click", () => {
      el.classList.remove("show");
      onClose(false, filterParams);
    });
    el.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", (e) => {
        if (e.target.checked) {
          handleChangeFilterParams([...filterParams, { key: e.target.name, value: e.target.value }]);
          return;
        }
        const newFilterParams = filterParams.filter((kv) => kv.key != e.target.name || kv.value != e.target.value);
        handleChangeFilterParams(newFilterParams);
      });
    });
    el.querySelectorAll(".fs-brand-menu-abc-header-item").forEach((itemEl) => {
      itemEl.addEventListener("click", (e) => {
        const title = e.target.dataset.title;
        const mode = e.target.dataset.mode;
        const container = el.querySelector(".fs-collection-filter-sp-brands-drawer");
        const target = container.querySelector(`.fs-item[data-title="${title}"`);
        const containerRect = container.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const top = targetRect.top + container.scrollTop - 72 - 52 - 48 - containerRect.top;
        container.scrollTo({ top: top, behavior: "smooth" });
      });
    });
  };

  const show = (newFilterParams) => {
    filterParams = FilterParamsUtil.duplicate(newFilterParams);
    handleChangeFilterParams(newFilterParams);
    el.classList.add("show");
    const container = el.querySelector(".fs-collection-filter-sp-brands-drawer");
    container.scrollTo({ top: top });
  };

  const handleChangeFilterParams = (newFilterParams) => {
    if (filterParams == newFilterParams) {
      return;
    }
    el.querySelectorAll("input").forEach((input) => {
      input.checked = false;
      if (0 <= newFilterParams?.findIndex((kv) => kv.key == input.name && kv.value == input.value)) {
        input.checked = true;
      }
    });
    filterParams = newFilterParams;
  };

  initialize();

  return {
    show: show,
  };
};

export default CollectionFilterSpBrands;
